/* ======================================================================== */
/* 35. ProjectBackgrounds */
/* ======================================================================== */
var ProjectBackgrounds = function () {

	if (!window.$backgrounds.length) {
		return;
	}

	var $ajaxLinks = $('a[data-post-id]');

	window.$header.find($ajaxLinks)
		.on('mouseenter touchstart', function () {
			var
				postId = $(this).data('post-id'),
				$targetBackground = window.$backgrounds.filter('[data-background-for="' + postId + '"]');

			if (!$targetBackground.length) {
				return;
			}

			window.$backgrounds.filter('active').removeClass('active');
			$targetBackground.addClass('active');

		})
		.on('mouseleave touchend', function () {

			window.$backgrounds.filter('.active').removeClass('active');

		});

	$ajaxLinks.on('click', function () {

		var
			postId = $(this).data('post-id'),
			$targetBackground = window.$backgrounds.filter('[data-background-for="' + postId + '"]');

		if (!$targetBackground.length) {
			return;
		}

		window.$backgrounds.filter('active').removeClass('active');
		$targetBackground.addClass('selected');

	});

}
